import { laravelHttpClient } from "../../../adlevo-vue/axios/axios";
import HttpService from "../../../adlevo-vue/services/http/httpService";
import { __loco } from "../../../utils/localization";

export default class WhiteLabelInspiration extends HttpService {
    constructor() {
        super(laravelHttpClient);
    }
    async getInspiration(inspirationId, page, itemPerPage) {

        const url = '/white-label/inspiration/' + inspirationId + '?page=' + page + '&item_per_page=' + itemPerPage;
        try {
            const response = await this.axios.get(url);
            return response.data
        } catch (error) {
            throw new Error(__loco('failed to Fetch Inspiration'));
        }
    }


}